import { render, staticRenderFns } from "./AppMenu0.vue?vue&type=template&id=4db9f36e&"
import script from "./AppMenu0.vue?vue&type=script&lang=js&"
export * from "./AppMenu0.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports